<template>
  <v-navigation-drawer app v-model="drawer" width="250" disable-resize-watcher right overlay-opacity="0.8">
    <!-- 博主介绍 -->
    <div class="blogger-info">
      <v-avatar class="blogger-avatar" size="110" >
        <img :src="this.$store.getters.blogAvatar" alt=""/>
      </v-avatar>
    </div>
    <!-- 博客信息 -->
    <div class="blog-info-wrapper">
      <div class="blog-info-data">
        <router-link to="/archives">
          <div calss="data-title" >文章</div>
          <div class="data-count" >
            {{ this.$store.getters.articleCount }}
          </div>
        </router-link>
      </div>
      <div class="blog-info-data">
        <router-link to="/categories">
          <div calss="data-title" >分类</div>
          <div class="data-count" >
            {{ this.$store.getters.categoryCount }}
          </div>
        </router-link>
      </div>
      <div class="blog-info-data">
        <router-link to="/tags">
          <div calss="data-title" >标签</div>
          <div class="data-count" >
            {{ this.$store.getters.tagCount }}
          </div>
        </router-link>
      </div>
    </div>
    <hr />
    <!-- 页面导航 -->
    <div class="menu-container">
      <div class="menus-item">
        <router-link to="/">
          <svg-icon icon-class="home" /> 首页
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/archives">
          <svg-icon icon-class="archive" /> 归档
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/categories">
          <svg-icon icon-class="category" /> 分类
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/tags">
          <svg-icon icon-class="tag" /> 标签
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/links">
          <svg-icon icon-class="link" /> 友链
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/about">
          <svg-icon icon-class="send" /> 关于
        </router-link>
      </div>
      <div class="menus-item">
        <router-link to="/message">
          <svg-icon icon-class="comment" /> 留言
        </router-link>
      </div>
      <div class="menus-item" v-if="!this.$store.getters.avatar">
        <a @click="openLogin"><svg-icon icon-class="login" /> 登录 </a>
      </div>
      <div v-else>
        <div class="menus-item">
          <router-link to="/user">
            <svg-icon icon-class="about-me" /> 个人中心
          </router-link>
        </div>
        <div class="menus-item">
          <a @click="logout"><svg-icon icon-class="exit" /> 退出</a>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped>
.blogger-info {
  padding: 26px 30px 0;
  text-align: center;
  .blogger-avatar {
    margin-bottom:0.5rem
  }
}
.blog-info-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 10px 0;
  .blog-info-data {
    flex: 1;
    line-height: 2;
    text-align: center;
    .data-title {
      font-size: 0.875rem;
    }
    .data-count {
      font-size: 1.125rem;
    }
  }
}
hr {
  border: 2px dashed #d2ebfd;
  margin: 20px 0;
}
.menu-container {
  padding: 0 10px 40px;
  animation: 0.8s ease 0s 1 normal none running sidebarItem;
  .menus-item {
    a {
      padding: 6px 30px;
      display: block;
      line-height: 2;
    }
    .svg-icon {
      margin-right: 2rem;
      top: -2px;
    }
  }
}

@keyframes sidebarItem {
  0% {
    transform: translateX(200px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>

<script>
import { userLogout } from "@/api/login";
export default {
  computed: {
    drawer: {
      set(value) {
        this.$store.dispatch('app/setDrawer',value);
      },
      get() {
        return this.$store.getters.drawer;
      }
    },
    isLogin() {
      return this.$store.getters.userId;
    }
  },
  methods: {
    openLogin() {
      this.$store.dispatch('app/setLoginFlag',true);
    },
    logout() {
      //如果在个人中心则跳回上一页
      if (this.$route.path == "/user") {
        this.$router.go(-1);
      }
      userLogout().then(res => {
        if (res.flag) {
          this.$cookie.delete("username");
          this.$cookie.delete("password");
          this.$store.commit("SET_LOGOUT");
          this.$toast({ type: "success", message: res.msg });
        } else {
          this.$toast({ type: "error", message: res.msg });
        }
      });
    }
  }
};
</script>
